import request from '@/utils/request'

//大事记
export function getcontenmemorabilia(params) {
  return request({
    url: '/api/contenmemorabilia/list',
    method: 'get',
    params
  });
}
export function getcontenmemorabiliaInfo(id) {
  return request({
    url: '/api/contenmemorabilia/info/'+id,
    method: 'get',
  });
}

//场馆介绍
export function getVenueIntroduction(params) {
  return request({
    url: '/api/contenvenueintroduction/getVenueIntroduction',
    method: 'get',
    params
  });
}

// 机构设置
export function getjgList(params) {
  return request({
    url: '/api/conteninstitutionalsetting/list',
    method: 'get',
    params
  });
}
export function getjgInfo(id) {
  return request({
    url: '/api/conteninstitutionalsetting/info/'+id,
    method: 'get',
  });
}



// WEBPACK FOOTER //
// ./src/api/overview/index.js